export const setCookie = (name, value, expDays = 1) => {
    let date = new Date();
    date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + '; ' + expires + '; path=/';
};

export const getCookie = name => {
    name = name + '=';
    const decoded = decodeURIComponent(document.cookie);
    const arr = decoded.split('; ');
    let res;
    arr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    });
    return res;
};
